import React from 'react';
import { ClipboardList, PenTool, Hammer, PartyPopper } from 'lucide-react';
export function Process() {
  const steps = [{
    icon: <ClipboardList className="w-8 h-8 text-teal" data-id="element-136" />,
    title: 'Free Estimate',
    description: 'We visit your property, discuss your vision, and provide a transparent, detailed quote.'
  }, {
    icon: <PenTool className="w-8 h-8 text-teal" data-id="element-137" />,
    title: 'Custom Design',
    description: 'Select your premium materials—pavers, travertine, or turf—and we finalize the layout.'
  }, {
    icon: <Hammer className="w-8 h-8 text-teal" data-id="element-138" />,
    title: 'Professional Install',
    description: 'Our experienced crews arrive on time, prep the site properly, and install with precision.'
  }, {
    icon: <PartyPopper className="w-8 h-8 text-teal" data-id="element-139" />,
    title: 'Enjoy Your Space',
    description: 'We clean up the site completely, leaving you with a stunning, ready-to-use outdoor oasis.'
  }];
  return <section id="process" className="py-20 md:py-28 bg-sand" data-id="element-140">
      <div className="container mx-auto px-4" data-id="element-141">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-142">
          <h2 className="text-3xl md:text-5xl font-extrabold font-heading text-charcoal mb-6 tracking-tight" data-id="element-143">
            How It Works
          </h2>
          <p className="text-lg text-charcoal/80" data-id="element-144">
            A seamless, professional process from the first call to the final
            walkthrough.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-12 relative" data-id="element-145">
          {/* Connecting line for desktop */}
          <div className="hidden lg:block absolute top-12 left-[12.5%] right-[12.5%] h-0.5 bg-taupe/50 z-0" data-id="element-146"></div>

          {steps.map((step, index) => <div key={index} className="relative z-10 flex flex-col items-center text-center group" data-id="element-147">
              <div className="w-24 h-24 rounded-full bg-white shadow-lg flex items-center justify-center mb-6 relative group-hover:-translate-y-2 transition-transform duration-300" data-id="element-148">
                {step.icon}
                <div className="absolute -top-2 -right-2 w-8 h-8 rounded-full bg-teal text-white font-bold flex items-center justify-center text-sm border-2 border-sand" data-id="element-149">
                  {index + 1}
                </div>
              </div>
              <h3 className="text-xl font-bold font-heading text-charcoal mb-3" data-id="element-150">
                {step.title}
              </h3>
              <p className="text-charcoal/70 leading-relaxed max-w-xs" data-id="element-151">
                {step.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}